export default function getAccounts(currentHallType = 1) {
    currentHallType = currentHallType || 1
    const accountMap = {
        1: 'showroom',
        2: 'Malaysia_Demo',
        3: 'Vietnam_Demo',
        4: 'Thailand_Demo',
        5: 'showfortw',
        6: 'Korean_Demo'
    }
    return {
        account: 'player' + String(Math.ceil(Math.random() * 100)).padStart(3,'0'),
        merchantAccount: accountMap[currentHallType],
        password: currentHallType == 1 ? '000000' : 'a123456',
    }
}